import Component from "../core/Component"
import { EMITS as SLIDER_EMITS } from "./Slider"

export default class ProductTechnicalPaper extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            slider: null,
            total: null,
        }
    }

    prepare() {
        if (this.ref.slider) {
            this.slider = Component.getFromElement(this.ref.slider)
            this.slider.on(SLIDER_EMITS.SELECTED, this.handleSliderSelected)
        }
    }

    handleSliderSelected = () => {
        this.ref.total.innerHTML = `${this.slider.flickity.selectedIndex + 1} / ${this.slider.flickity.cells.length}`
    }
}
